export const IRA_AMOUNT = {
  TRADITIONAL_IRA_AMOUNT: 'traditionalIraAmount',
  TRADITIONAL_PRE_TAX: 'traditionalIraPreTaxAmount',
  TRADITIONAL_AFTER_TAX: 'traditionalIraAfterTaxAmount',
  ROTH: 'rothIraAmount',
}
